import React from "react";

function Modal({ setShowModal, props, Confirm }) {
  const Cancel = (e) => {
    e.preventDefault();
    setShowModal(false);
    // document.querySelector(".overlay").classList.add("hide");
  };

  let isPermitLov = props.postageType === "Permit Postage Posting (BRM/BRC)";
  let isPostalStatement = props.postageType === "Postal Statement";
  let isPoBoxRenual = props.postageType === "PO Box Renewal";
  const pieces = parseFloat(props.numberOfPieces || "0");
  const total = parseFloat(props.totalAmount || "0");

  const safeTrunc3 = (num) =>
  Math.trunc(Math.round(num * 1000000) / 1000) / 1000;

  const isRateMatch = (total, rate, piecesStr) => {
  const piecesProvided = Number(piecesStr);
  if (!Number.isFinite(piecesProvided) || piecesProvided <= 0) return false;

  const actualPieces = total / rate;

  const expected3 = safeTrunc3(actualPieces);
  const provided3 = safeTrunc3(piecesProvided);

  return Math.abs(expected3 - provided3) < 1e-9;
};
  // ...existing code...

  let isTotalmismatch = false;
  if (pieces > 0) {
    isTotalmismatch = !isRateMatch(total, pieces, props.ratePerItem);
  }

  return (
    <div id="infoModal" className="overlay">
      <div className="popup clearfix">
        <div className="body">
          <div className="group">
            <div className="span12">
              <h3>Please Confirm That Data Entered Is Accurate</h3>
              {/* <button className="close">×</button> */}
              <div className="overlay-content">
                <form>
                  <div className="group">
                    <div className="field span12">
                      <div className="text-pad">
                        {" "}
                        <strong>Master key:</strong> {props.masterNumber}{" "}
                      </div>
                      <div className="text-pad">
                        {" "}
                        <strong>LOV:</strong> {props.postageType}{" "}
                      </div>
                      <div className="text-pad">
                        {" "}
                        <strong>Total Amount:</strong> {props.totalAmount}{" "}
                      </div>
                      {(isPermitLov || isPostalStatement) && (
                        <>
                          <div className="text-pad">
                            {" "}
                            <strong>Number of Pieces:</strong>{" "}
                            {props.numberOfPieces}{" "}
                          </div>
                          <div className="text-pad">
                            {" "}
                            <strong>Rate per Item:</strong> {props.ratePerItem}{" "}
                          </div>
                        </>
                      )}
                      {(isPostalStatement || isPermitLov) && (
                        <>
                          <div className="text-pad">
                            {" "}
                            <strong>Permit Number:</strong> {props.permitNumber}{" "}
                          </div>
                          <div className="text-pad">
                            {" "}
                            <strong>Order Number:</strong> {props.orderNumber}{" "}
                          </div>
                        </>
                      )}
                      {isPoBoxRenual && (
                        <>
                          <div className="text-pad">
                            {" "}
                            <strong>PO Box Number:</strong> {props.poBoxNumber}{" "}
                          </div>
                        </>
                      )}
                      {isPermitLov && isTotalmismatch && (
                        <div className="text-pad">
                          <p style={{ color: "red" }}>
                            Number of pieces x rate does not equal the total
                            amount
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </form>
                <div className="right close-modal">
                  <button
                    type="button"
                    className={
                      isPermitLov && isTotalmismatch
                        ? "btn-disabled right"
                        : "btn-blue right"
                    }
                    disabled={isPermitLov && isTotalmismatch ? true : false}
                    onClick={Confirm}
                  >
                    Confirm
                  </button>
                </div>
                <button className="btn-red right" onClick={Cancel}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Modal;
